<template>
    <div class="bidder-project-workflow">
        <div class="main-workflow">
            <!-- 顶部工具栏 -->
            <div class="project-flow-toolbar">
                <div class="project-flow-toolbar__meta">
                    <h2 class="project-flow-toolbar__title">
                        {{ projectTitle }}
                    </h2>
                    <div v-if="bidSectionName" class="project-flow-toolbar__section">
                        <span class="project-flow-toolbar__section-label">标段名称</span>
                        <span class="project-flow-toolbar__section-value">{{ bidSectionName }}</span>
                    </div>
                </div>
            </div>

            <!-- 三列 grid 布局，每列对应一个主阶段 -->
            <div class="workflow-grid">
                <!-- ========== 列1：发标 ========== -->
                <div class="grid-col">
                    <!-- 主阶段行内布局 -->
                    <div class="stage-row">
                        <img src="@/assets/image/bidProProcess-one-left.png" class="deco-left" />
                        <div class="content" style="border-radius: 0; box-shadow: none; background-color: #11c2eb;">发标
                        </div>
                        <img src="@/assets/image/bidProProcess-one-right.png" class="deco-right" />
                    </div>
                    <!-- 步骤纵向布局 -->
                    <div class="stage-step">
                        <div class="stage-icon-content">
                            <img :src="hoveredStage === '招标公告' ? require('@/assets/image/bidProProcess-hover-after.png') : require('@/assets/image/bidProProcess-one-after.png')"
                                class="stage-icon" />
                        </div>
                        <div class="content" style="background-color: #11c2eb;" @mouseenter="hoveredStage = '招标公告'"
                            @mouseleave="hoveredStage = null"
                            @click="handleStepClick('招标公告', '/bidderHome/bidAnnouncementPublish?sectionCode=' + sectionCode + '&projectCode=' + projectInfo.projectCode)">
                            招标公告
                        </div>
                    </div>
                </div>

                <!-- ========== 列2：投标 ========== -->
                <div class="grid-col">
                    <!-- 主阶段行内布局 -->
                    <div class="stage-row">
                        <img src="@/assets/image/bidProProcess-two-left.png" class="deco-left" />
                        <div class="content" style="border-radius: 0; box-shadow: none; background-color: #0ed7c6;">投标
                        </div>
                        <img src="@/assets/image/bidProProcess-two-right.png" class="deco-right" />
                    </div>
                    <!-- 步骤纵向布局 -->
                    <div class="stage-step">
                        <div class="stage-icon-content">
                            <img :src="hoveredStage === '下载招标文件' ? require('@/assets/image/bidProProcess-hover-after.png') : require('@/assets/image/bidProProcess-tow-after.png')"
                                class="stage-icon" />
                        </div>
                        <div class="content" style="background-color: #0ed7c6;" @mouseenter="hoveredStage = '下载招标文件'"
                            @mouseleave="hoveredStage = null"
                            @click="handleStepClick('下载招标文件', '/bidderHome/downloadTender')">
                            下载招标文件
                        </div>
                    </div>
                </div>
                <!-- ========== 列3：定标 ========== -->
                <div class="grid-col">
                    <!-- 主阶段行内布局 -->
                    <div class="stage-row">
                        <img src="@/assets/image/bidProProcess-one-left.png" class="deco-left" />
                        <div class="content" style="border-radius: 0; box-shadow: none; background-color: #11c2eb;">定标
                        </div>
                        <img src="@/assets/image/bidProProcess-one-right.png" class="deco-right" />
                    </div>
                    <!-- 步骤纵向布局 -->
                    <div class="stage-step">
                        <div class="stage-icon-content">
                            <img :src="hoveredStage === '中标候选人公示' ? require('@/assets/image/bidProProcess-hover-after.png') : require('@/assets/image/bidProProcess-one-after.png')"
                                class="stage-icon" />
                        </div>
                        <div class="content" style="background-color: #11c2eb;" @mouseenter="hoveredStage = '中标候选人公示'"
                            @mouseleave="hoveredStage = null"
                            @click="handleStepClick('中标候选人公示', '/bidderHome/winCandidateList?sectionCode=' + sectionCode+ '&projectCode=' + projectInfo.projectCode)">
                            中标候选人公示
                        </div>
                    </div>
                    <!-- 步骤纵向布局 -->
                    <div class="stage-step">
                        <div class="stage-icon-content">
                            <img :src="hoveredStage === '中标公告' ? require('@/assets/image/bidProProcess-hover-after.png') : require('@/assets/image/bidProProcess-tow-after.png')"
                                class="stage-icon" />
                        </div>
                        <div class="content" style="background-color: #0ed7c6;" @mouseenter="hoveredStage = '中标公告'"
                            @mouseleave="hoveredStage = null"
                            @click="handleStepClick('中标公告', '/bidderHome/winBulletinList?sectionCode=' + sectionCode + '&projectCode=' + projectInfo.projectCode)">
                            中标公告
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { getBidSectionInfo } from '@/api/modules/bidEvaluationCommittee'
import { getBidderFlowTitle } from '@/utils/bid/projectInfo'
import { getProjectInfo } from '@/api/modules/bidEvaluationCommittee'
export default {
    name: 'BidderProjectWorkflow',

    data() {
        return {
            sectionCode: '',
            bidSectionName: '',
            projectTitle: '',
            hoveredStage: null,
            projectInfo: {}
        }
    },

    created() {
        this.sectionCode = this.$route.query.sectionCode || ''
        this.getBidSectionInfo()
        this.getProjectInfo()
    },

    methods: {
        async getProjectInfo() {
            this.projectTitle = await getBidderFlowTitle(this.sectionCode)
            const res = await getProjectInfo(this.sectionCode)
            this.projectInfo = res.data


        },

        async getBidSectionInfo() {
            const res = await getBidSectionInfo(this.sectionCode)
            if (res.code == 200) {
                this.bidSectionName = res.data.bidSectionName
            } else {
                this.$message.error(res.msg)
            }
        },

        handleStepClick(name, route) {
            if (!route) return
            this.$router.push({ path: route, query: { sectionCode: this.sectionCode } })
        }
    }
}
</script>

<style lang="less" scoped>
@import '@/styles/minimal-gray-theme.less';

.bidder-project-workflow {
    .apply-minimal-gray-theme();
}

// 页面头部
.project-flow-toolbar {
    width: 100%;
    min-height: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 16px;
}

.project-flow-toolbar__meta {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
}

.project-flow-toolbar__title {
    margin: 0;
    color: @gray-700;
    font-size: 22px;
    font-weight: 700;
    line-height: 1.4;
    text-align: center;
    word-break: break-word;
}

.project-flow-toolbar__section {
    display: inline-flex;
    align-items: center;
    align-self: center;
    max-width: 100%;
    padding: 8px 14px;
    border-radius: 999px;
    background: linear-gradient(90deg, rgba(17, 194, 235, 0.1) 0%, rgba(14, 215, 198, 0.12) 100%);
    border: 1px solid rgba(17, 194, 235, 0.18);
    box-sizing: border-box;
    gap: 10px;
}

.project-flow-toolbar__section-label {
    flex-shrink: 0;
    padding: 2px 10px;
    border-radius: 999px;
    background: linear-gradient(135deg, #11c2eb 0%, #0ed7c6 100%);
    color: #fff;
    font-size: 12px;
    font-weight: 600;
    line-height: 20px;
}

.project-flow-toolbar__section-value {
    min-width: 0;
    color: @gray-700;
    font-size: 14px;
    font-weight: 600;
    line-height: 1.4;
    word-break: break-word;
}

// 主要流程区域
.main-workflow {
    display: flex;
    align-items: center;
    flex-direction: column;
    padding: 24px;
    background: #fff;
    border-radius: 8px;
    box-shadow: @shadow-sm;
    overflow-x: auto;
}

// ========== 三列 grid 布局 ==========
.workflow-grid {
    margin-top: 20px;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 0;
    width: 100%;
    max-width: 800px;
}

.grid-col {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
}

// ========== 主阶段行内布局 ==========
.stage-row {
    display: flex;
    align-items: center;
    cursor: pointer;
    margin-bottom: 8px;

    &:hover {
        transform: translateY(-2px);
    }

    .deco-left,
    .deco-right {
        height: 45px;
        width: auto;
        flex-shrink: 0;
    }

    .content {
        height: 45px;
        width: 200px;
        text-align: center;
        line-height: 45px;
        font-size: 15px;
        color: #fff;
        font-weight: 600;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        border-radius: 0;
        cursor: pointer;
        box-shadow: none;
    }
}

// ========== 步骤纵向布局 ==========
.stage-step {
    display: flex;
    flex-direction: column;
    align-items: center;
    cursor: pointer;

    &:hover {
        transform: translateY(-2px);
    }

    .stage-icon-content {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 5px;

        .stage-icon {
            width: 14px;
            height: 9px;
        }
    }

    .content {
        height: 45px;
        width: 200px;
        text-align: center;
        line-height: 45px;
        font-size: 14px;
        color: #fff;
        font-weight: 600;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        border-radius: 25px;
        cursor: pointer;
        transition: all 0.3s ease;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

        &:hover {
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        }
    }
}
</style>
